var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page"},[(_vm.loading)?_c('loader'):_vm._e(),_c('router-view'),_c('popup-list',{attrs:{"popups":_vm.popups}}),_c('pwa-tooltip')],1)}
var staticRenderFns = []

export { render, staticRenderFns }